import { Observable } from 'rxjs';
import { Blog } from '../models/blog.model';

export abstract class BlogRepository {
    abstract getBlogs(): Observable<Blog>;
}
